import {SpaceProto} from "../space-proto";
import ProjectSession from "../../project/project-session";


export default function space_getProjectsColorize(space:SpaceProto):boolean {

    // return gd.user.settings.navigation.spacesPreferences[space.id]?.projectsColorize || false

    const userSettingsValue : boolean | undefined = gd.user.settings.navigation.spacesPreferences[space.id]?.projectsColorize

    if (userSettingsValue!==undefined) {
        // @ts-ignore
        return userSettingsValue
    }

    // otherwise need default

    // check if project has it set !
    if (space.isWorkspace || space.isSection) {

        // @ts-ignore
        const project: ProjectSession = space.project

        if (!_.isNil(project.properties.defaultColorize)) {
            // @ts-ignore
            return project.properties.defaultColorize
        }

    }

    // default failback ...
    return false


}